import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class LogisticsVerification {
  /* 重量核验列表 */
  static getLogisticsVerificationList(options) {
    let url = `/oa/api/express/bill/list?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 金额核验导入接口 */
  static postAmountVerificationExcel(data) {
    const url = `/oa/api/upload/express/init/order/by/amount`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 列表上传数据
  static postListExcel(data) {
    const url = `/oa/api/upload/express/check/order`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 初始账单导入
  static postExcel(data) {
    const url = `/oa/api/upload/express/init/order`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 完成核验
  static postFinishLogisticsVerification(data) {
    const url = `/oa/api/express/bill/check`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 下载差异单量接口 */
  static getDownloadLogisticsVerificatio(options) {
    let url = `/oa/api/download/express/diff/order/list?`;
    url += handleGetRequestParams(options)
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
  /* 物流加收费列表 */
  static getLogisticsPlusChargesList(options) {
    let url = `/oa/api/logistics/surcharge/list?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 物流加收费账单导入
  static postLogisticsPlusChargesExcel(data) {
    const url = `/oa/api/upload/logistics/surcharge`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }


  /* ***** 以下是新物流核验接口 ***** */

  // 物流核验列表(新)
  static getNewLogisticsVerificationList(options) {
    let url = `/oa/api/express/bill/receivable/list?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 创建物流核验
  static postCreateLogisticsVerification(data) {
    const url = `/oa/api/express/bill/save`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 删除物流核验记录
  static postDelLogisticsVerification(id) {
    const url = `/oa/api/express/bill/remove/${id}`
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 物流核验记录详情
  static postLogisticsVerificationDetails(id) {
    const url = `/oa/api/express/bill/receivable/detail/${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 上传快递承运商账单
  static postUploadExpressBillExcel(data) {
    const url = `/oa/api/express/bill/upload/express/order`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 上传物流承运商账单
  static postUploadLogisticsBillExcel(data) {
    const url = `/oa/api/express/bill/upload/logistics/order`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 上传快递加收费账单
  static postUploadLogisticsSurchargeBillExcel(data) {
    const url = `/oa/api/express/bill/upload/logistics/surcharge/order`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 手工单匹配--强制跳过
  static postManualOrderForceSkip(id) {
    const url = `/oa/api/express/bill/manual/order/force/skip/${id}`
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 手工单匹配--手动刷新
  static postManuallyRefresh(id) {
    const url = `/oa/api/express/bill/manual/order/manually/refresh/${id}`
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 手工单匹配--完成匹配
  static postManuallyOrderCompleteMatching(id) {
    const url = `/oa/api/express/bill/manual/order/complete/matching/${id}`
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 重量/金额校对差异单量下载
  static postDownloadExpressDiffOrder(options) {
    let url = `/oa/api/express/bill//download/express/diff/order?`;
    url += handleGetRequestParams(options)
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
  // 完成核验
  static postCompleteVerification(id) {
    const url = `/oa/api/express/bill/complete/${id}`
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default LogisticsVerification;